import _ from 'lodash'

class BodyController {
  constructor($http, $location, $window, $document, $analytics) {
    this.$http = $http
    this.$location = $location
    this.$window = $window
    this.$document = $document
    this.$analytics = $analytics
  }

  recordCopyEvent() {
    const selection = this.$document.selection
    const text = this.selectedText

    this.$analytics.eventTrack(
      'Text Copied',
      {
        'Character Count': text.length,
        'Selected Text': text
      }
    )
  }

  get selectedText() {
    const selection = this.$document.selection

    if (this.$window.getSelection) {
        return this.$window.getSelection().toString()
    } else if (selection && selection.type != "Control") {
        return selection.createRange().text
    }

    return null
  }
}

BodyController.$inject = ['$http', '$location', '$window', '$document', '$analytics']

export default BodyController
